import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: [],
  },
  getters: {
    details: (state) => state.details,
  },
  actions: {
    exportQuotaExcelWithFilter(defualtVal, filterData) {
      const agentName = filterData.agentName;
      const productInfo = filterData.productInfo;
      return ajax
        .get(
          "Sales/api/QuotaTransactionsQuery/excel-report?" +
            (productInfo ? "productInfo=" + productInfo + "&" : "") +
            (agentName ? "agentName=" + agentName : ""),
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let url = window.URL.createObjectURL(blob);
          window.location.href = url;
        })
        .catch((err) => {});
    },
    exportWebsiteQuotaExcelWithFilter(defualtVal, word) {
      return ajax
        .get(
          "Sales/api/QuotaTransactionsQuery/website-excel-report" +
            (word ? "?keyword=" + word : ""),
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let url = window.URL.createObjectURL(blob);
          window.location.href = url;
        })
        .catch((err) => {});
    },
    exportSaleAgentQuotaQueryWithInvertoryBalances(defualtVal, word) {
      return ajax
        .get(
          "Sales/api/QuotaTransactionsQuery/sale-agent-quotas-with-inventories-with-keyword-excel-file" +
            (word ? "?keyword=" + word : ""),
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let url = window.URL.createObjectURL(blob);
          window.location.href = url;
        })
        .catch((err) => {});
    },
    exportPricesQuery() {
      return ajax
        .get("Sales/api/PricesQuery/excel-report", { responseType: "blob" })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let url = window.URL.createObjectURL(blob);
          window.location.href = url;
        })
        .catch((err) => {});
    },
    exportCirculationOfSerialsQuery({ commit }, params) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Inventory/api/CirculationOfSerialsQuery/excel-file" + params, {
            responseType: "blob",
          })
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    importPrices({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Sales/api/Prices/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importPromotionExcel({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Promotion/api/ProductDiscounts/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importFixedPriceExcel({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "Sales/api/ContractProductsInfo/price/cumulative-manually-update-with-excel-file",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    exportOrderQuery({ commit }, params) {
      return new Promise((resolve, reject) => {
        ajax
          .get("/Sales/api/OrdersQuery/excel-report?" + params, {
            responseType: "blob",
          })
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportSamanehJameAgentsQuery({ commit }, params) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "/Sales/api/OrdersQuery/samaneh-jame/excel-report-of-sale-agent?" +
              params,
            {
              responseType: "blob",
            }
          )
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportSamanehJameCustomersQuery({ commit }, params) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "/Sales/api/OrdersQuery/samaneh-jame/excel-report-of-business-to-customer?" +
              params,
            {
              responseType: "blob",
            }
          )
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportDraftOrderQuery({ commit }, params) {
      return new Promise((resolve, reject) => {
        ajax
          .get("/Sales/api/DraftOrdersQuery/excel-report?" + params, {
            responseType: "blob",
          })
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportOrderItemsQuery({ commit }, { contractId, params }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/OrdersQuery/orderItems/excel-report?" + params, {
            responseType: "blob",
          })
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportOrderItemsReportQuery({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        ajax
          .get(`Sales/api/OrdersQuery/orderItems/${params}/excel-report` ,{
            responseType: "blob",
          })
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportDraftOrderItemsQuery({ commit }, { contractId, params }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/DraftOrdersQuery/items/excel-report?" + params, {
            responseType: "blob",
          })
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    importTransferTransactions({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/TransferTransactions/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importExcelSpecificProduct({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "Sales/api/SpecificProductDeductionAndIncreases/excel-file",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importExcelGenericProduct({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "Sales/api/GenericProductDeductionAndIncreases/excel-file",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importExcelReturnOrder({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Sales/api/ReturnOrders/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importSpecificProductDeductionAndIncreases({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "Sales/api/SpecificProductDeductionAndIncreases/excel-file",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importGenericProductDeductionAndIncreases({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "Sales/api/GenericProductDeductionAndIncreases/excel-file",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importQuotasChargeTransactions({ commit, dispatch }, { file, exDate }) {
      return new Promise((resolve, reject) => {
        ajax
          .post(
            "Sales/api/ChargeTransactions/quota/excel-file/" + exDate,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importQuotasDischargeTransactions({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Sales/api/DischargeTransactions/quota/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importCheckInExcel({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/CheckInTransactions/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    uploadFileToUpdateTheTrackingId({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/InventoryTransactions/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importCheckOutExcel({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/CheckOutTransactions/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    exportContractProductsQuery({ commit }, { id, SaleProductType }) {
      return ajax
        .get(
          "Sales/api/ContractsQuery/excel-file-of-contract-product-info/" +
            id +
            "?saleProductType=" +
            SaleProductType,
          { responseType: "blob" }
        )
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let url = window.URL.createObjectURL(blob);
          window.location.href = url;
        })
        .catch((e) => reject(e));
    },
    exportProductQuery({ commit }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/ProductQuery/excel-file", { responseType: "blob" })
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    importProductInBasketExcel(
      { commit, dispatch },
      { formData, agentId, partyId }
    ) {
      return new Promise((resolve, reject) => {
        ajax
          .post(
            "Sales/api/SaleAgentBasket/excel-file/" +
              agentId +
              (partyId ? "?partyId=" + partyId : ""),
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importAgentIndividuals({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/AgentIndividuals/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importAgentLegals({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/AgentLegals/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    exportbaseOnStockDraftOrderAccumulative({ commit }, params) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/CheckOutTransactionsQuery/base-on-stock-draft-order/excel-file" +
              params,
            {
              responseType: "blob",
            }
          )
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportbaseOnStockDraftOrderSerials({ commit }, params) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/CheckOutTransactionsQuery/base-on-stock-draft-order-per-serial/excel-file" +
              params,
            {
              responseType: "blob",
            }
          )
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportReportFile({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/CountingTagQuery/stock-taking/" +
              id +
              "/excel-report-of-all-counting-tags",
            {
              responseType: "blob",
            }
          )
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "specificProducts.xlsx";
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            // window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportItemCodesOfTheSerialsTakenFile({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/CountingTagQuery/stock-taking/" +
              id +
              "/excel-report-of-all-items-code-base-on-all-counting-tags",
            {
              responseType: "blob",
            }
          )
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "specificProducts.xlsx";
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            // window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportActualProducts({ commit }) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/ActualProductsQuery/excel-file", {
            responseType: "blob",
          })
          .then((res) => {
            commit("setDetails", res.data);
            commit("setLoading", false);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "actualProducts.xlsx";
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            // window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    importActualProducts({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("ProductManagement/api/ActualProducts/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    exportDividedByWarehousesAndShelveExcel({ commit }, model) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .post(
            "Inventory/api/InventoryTransactionsQuery/excel-file" ,model ,
            // {headers:{'X-Ignore-Modal':'ignoreModal'}},

            {
              responseType: "blob",
            }
          )
          .then((res) => {
            commit("setDetails", res.data);
            commit("setLoading", false);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "actualProducts.xlsx";
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            // window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },

    exportDividedByWarehousesAndShelveExcelWithoutSerial({ commit }, model) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .post(
            "Inventory/api/InventoryTransactionsQuery/excel-file-without-serials" ,model ,
            // {headers:{'X-Ignore-Modal':'ignoreModal'}},

            {
              responseType: "blob",
            }
          )
          .then((res) => {
            commit("setDetails", res.data);
            commit("setLoading", false);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "actualProducts.xlsx";
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            // window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },

    exportAllWarehousesExcel({ commit }, model) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/StockQuery/excel-file" , model, 
            // {headers:{'X-Ignore-Modal':'true'}},
            {responseType: "blob"}
          )
          .then((res) => {
            commit("setDetails", res.data);
            commit("setLoading", false);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "actualProducts.xlsx";
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            // window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportExcelAllSerials({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/CheckOutTransactionsQuery/" + id + "/excel-file",
            {
              responseType: "blob",
            }
          )
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    importCheckOutTransactions({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post(
            "Inventory/api/CheckOutTransactions/for-draft-order-with-excel-file",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    exportSpecificProducts({ commit }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/SpecificProductsQuery/excel-file", {
            responseType: "blob",
          })
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = "specificProducts.xlsx";
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            // window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    importSpecificProducts({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("ProductManagement/api/SpecificProducts/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },

    exportExcelSerialWithItemCode({ commit }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Shipping/api/PackagesQuery/excel-file/serials-of/" +
              model.packageId +
              "/" +
              model.itemCode,
            {
              responseType: "blob",
            }
          )
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportExcelAllSerialWithItemCode({ commit }, packageId) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Shipping/api/PackagesQuery/excel-file/items-of/" + packageId, {
            responseType: "blob",
          })
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => reject(e));
      });
    },
    exportExcelPackage({ commit }, filter) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Shipping/api/PackagesQuery/excel-file" + filter, {
            responseType: "blob",
          })
          .then((res) => {
            commit("setDetails", res.data);
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    importReservationReserve({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/Reserves/reserve-with-excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importReservationRecharge({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/Recharges/recharge-with-excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importBaseSalePriceExcel({ commit, dispatch }, { file, id }) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "/Sales/api/BaseSalePrice/assign-items-with-excel-file/" + id,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    exportChannelBaskets({ commit }, filter) {
      return new Promise((resolve, reject) => {
        ajax
          .get("/Sales/api/SaleAgentBasketsQuery/Excel?" + filter, {
            responseType: "blob",
          })
          .then((res) => {
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    sendSaleTargetSegmentsExcelFile(
      { commit, dispatch },
      { file, saleTargetId }
    ) {
      return new Promise((resolve, reject) => {
        ajax
          .post(
            `/Sales/api/SaleTargets/add-excel-file-for-segment-targets-on-sale-targets/${saleTargetId}`,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    sendSaleTargetSegmentSaleAgentsExcelFile(
      { commit, dispatch },
      { file, segmentId, saleTargetId }
    ) {
      return new Promise((resolve, reject) => {
        ajax
          .post(
            `/Sales/api/SaleTargets/add-excel-file-for-sale-agent-targets-base-on-segment-target/${segmentId}/on-sale-targets/${saleTargetId}`,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    exportAgents({ commit }, filter) {
      return new Promise((resolve, reject) => {
        ajax
          .get("/BusinessParties/api/AgentsInfoQuery/excel-report?" + filter, {
            responseType: "blob",
          })
          .then((res) => {
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    importSerials({ commit, dispatch }, { file, id }) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "/Shipping/api/ReceiveShipments/update-serials-with-excel-file/" + id,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importSerialsInPackage({ commit, dispatch }, { file, id , shipmentId}) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "/Shipping/api/Packages/update-serials-with-excel-file-of-package/"+ id +"/from-shipment/" + shipmentId,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    createPurchaseRequestByExcel({ commit, dispatch }, { file, departman , deliveryClock , description }) {
      return new Promise((resolve, reject) => {
        ajax
          .post(
            "/Procurements/api/PurchaseRequests/create-with-excel-file/" + departman  +'?deliveryClock=' + deliveryClock +'&description=' + description,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    createPurchaseOrderByExcel({ commit, dispatch }, { file, id }) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "/Procurements/api/PurchaseOrders/update-unit-price-with-excel/" + id  ,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    updatePurchaseOrderItemCode({ commit, dispatch }, { file, id }) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "/Procurements/api/PurchaseInvoices/update-items-code-with-excel?purchaseInvoiceId=" + id  ,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    updateWeight({ commit, dispatch }, { file, id }) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "/Procurements/api/PurchaseInvoices/update-weights-of-purchases-invoice-items-with-excel?purchaseInvoiceId=" + id  ,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importPackage({ commit, dispatch }, { file, id }) {
      return new Promise((resolve, reject) => {
        ajax
          .put(
            "/Shipping/api/Shipments/upload-packing-lists-with-excel-file/" + id,
            file,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },

    exportTargetSaleAgents({ commit }, { saleTargetId, segmentTargetId }) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            `/Sales/api/SaleTargetsQuery/excel-report-of-sales-agents-targets?saleTargetId=${saleTargetId}&segmentTargetId=${segmentTargetId}`,
            {
              responseType: "blob",
            }
          )
          .then((res) => {
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    importIndividualCustomers({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post(
            "BusinessParties/api/CustomerIndividuals/excel-file",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importLegalCustomers({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/CustomerLegals/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importSupplierIndividuals({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/SupplierIndividuals/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    importSupplierLegals({ commit, dispatch }, formData) {
      return new Promise((resolve, reject) => {
        ajax
          .post("BusinessParties/api/SupplierLegals/excel-file", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    exportSuppliers({ commit }, filter) {
      return new Promise((resolve, reject) => {
        ajax
          .get("/BusinessParties/api/SuppliersInfoQuery/excel-report", {
            responseType: "blob",
          })
          .then((res) => {
            resolve(res.data);
            let blob = new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            window.location.href = url;
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
  },
};
